import React from "react";
import { useParams } from "react-router-dom";
import Teknion from "./Teknion";

export default function TeknionFunctional() {
  let id = useParams();
  // console.log(id);
  return (
    <div>
      <Teknion matchparams={id} />
    </div>
  );
}
